import { Breakpoint, styled } from '@mui/material';
import Box from '@mui/material/Box';
import { CSSObject } from '@mui/system';

export const StickyPanel = styled(Box, {
    name: 'StickyPanel',
    slot: 'Root',
})(
    ({ theme }) =>
        (({
            background: theme.palette.background.paper,
            position: 'sticky',
            marginTop: 3.5,
            top: theme.settings?.appBar?.spacer().xxl,

            ...Object.entries(theme.settings?.appBar?.spacer()).reduce((res, [breakpoint, height]) => {
                res[theme.breakpoints.down(breakpoint as Breakpoint)] = {
                    top: height,
                };
                return res;
            }, {} as CSSObject),

            zIndex: theme.zIndex.appBar - 1
        }) as CSSObject)
);
